import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cb326fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block p-2 text-gray-700" }, "Select a node or edge to configure", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "w-full p-3"
}
const _hoisted_5 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:text-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-lg leading-6 font-medium text-gray-900",
  id: "modal-title"
}, "Edit content", -1))
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://commonmark.org/help/",
  target: "_blank"
}, "markdown", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, [
  /*#__PURE__*/_createTextVNode(" Docassmble uses Mako as a templating system, to allow for including variables and code in content. More on how to use this at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docassemble.org/docs/markup.html#mako",
    target: "_blank"
  }, "Docassemble"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, [
  /*#__PURE__*/_createTextVNode(" Note that when referencing a variable, even in an 'if' statement, the block corresponding to the variable will be first shown to the user (regardless of the order specified in the graph). To show a variable only when it is defined, one can use the "),
  /*#__PURE__*/_createElementVNode("span", { class: "code text-gray-700" }, "defined('variable')"),
  /*#__PURE__*/_createTextVNode(" function within Mako, as described at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docassemble.org/docs/markup.html#mako",
    target: "_blank"
  }, "Docassemble"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "mb-2 text-ellipsis overflow-hidden font-mono block text-xl border-b border-gray-300" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "my-2" }
const _hoisted_21 = { class: "mt-1 mb-3 block border-b border-gray-300 text-lg leading-6 font-medium text-gray-800" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 block mb-1 text-sm" }, "Variable", -1))
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flex justify-between items-center mb-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700 block text-sm",
  for: "textarea_content"
}, "Content", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  class: "w-full p-2"
}
const _hoisted_31 = { class: "" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-2 font-bold block text-2xl border-b border-gray-300" }, "Edge", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "my-2"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my-2 block border-b border-gray-300 uppercase font-bold text-sm text-gray-800" }, "General", -1))
const _hoisted_37 = { class: "block mt-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 block mb-1" }, "Label", -1))
const _hoisted_39 = { class: "w-full my-2 text-right" }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Invalid cell selected", -1))
const _hoisted_42 = [
  _hoisted_41
]

import { computed, ref } from 'vue';
    import { default_edge_label, node_types, node_type_default, AntvNodeData } from '@/utils/antv-model'

    import { Cell, Edge, Node } from '@antv/x6'

    import titleCase from '@/utils/data/titleCase';
    import { Modal } from '@/utils/modal';
    import ModalComponent from '@/components/shared/ModalComponent.vue';

    import EasymdeView from '@/components/shared/easymde'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GraphModelerConfigBar',
  props: {
    cell: {}
  },
  setup(__props: any) {


    const props = __props;
    
    /* Modal definitions */
    // const modal_field_content_editor = ref('');
    const modal_field_content = new Modal({read_more: false, editor: ''}, {
        onOpen: () => {
            modal_field_content.data.editor = node_content.value;
        }
    });
    const modal_field_content_accept = (modal: typeof modal_field_content) => {
        node_content.value = modal.data.editor;
        modal.close();
    }

    /* Computing current fields */
    const current_fields = computed(() => {
        const field = props.cell?.getData()?.node_type ?? node_type_default;
        let current_node_fields = null;

        if (Object.keys(node_types).includes(field))
            current_node_fields = node_types[field as keyof node_types].config_fields;
        else
            current_node_fields = node_types[node_type_default].config_fields;

        // https://stackoverflow.com/a/62400741/17864167
        return Object.fromEntries(
            Object.entries(current_node_fields)
                .filter(([key, val]) => val.length > 0)
        )
    });

    /* Computed properties as 'middleman' for entered data and antvis model. */

    // The `utils/graph.ts` can't be used for storing data as it would require
    // updating antvis, based on graph.ts, on every (content) update.

    const node_content_ref = ref('');
    const node_content = computed({
        get() {
            // https://github.com/antvis/X6/issues/2020#issuecomment-1104644438
            // return (props.cell as Node).getAttrByPath('text/text') as string
            node_content_ref.value;
            return (props.cell as Node).getData().gd.content ?? '';
        },
        set(value: string) {
            // (props.cell as Node).setAttrByPath('text/text', value)
            node_content_ref.value = value;
            (props.cell as Node).setData({gd: {content: value}});
        }
    });

    const node_variable_ref = ref('');
    const node_variable = computed({
        get() {
            node_variable_ref.value;
            return ((props.cell as Node).getData() as AntvNodeData).gd.variable ?? '';
        },
        set(value: string) {
            node_variable_ref.value = value;
            (props.cell as Node).setData({gd: {variable: value != '' ? value : null}});
        }
    });

    // only reason for 'edge_content_ref' is for adding reactivity to edge_content,
    // relevant for pressing buttons
    const edge_content_ref = ref('');
    const edge_content = computed({
        get() {
            const edge = props.cell as Edge;
            edge_content_ref.value;
            return edge.getLabelAt(0)?.attrs?.text?.text?.toString() ?? '';
        },
        set(value: string) {
            const edge = props.cell as Edge;

            const edge_label = default_edge_label(value);
            if (edge_label != null) {
                edge.removeLabelAt(0);
                edge.setLabelAt(0, edge_label);
            }

            edge_content_ref.value = value;
            edge.setData({value})
        }
    });


return (_ctx: any,_cache: any) => {
  return (_ctx.cell == null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.cell.isNode())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(modal_field_content).is_open)
            ? (_openBlock(), _createBlock(ModalComponent, {
                key: 0,
                modal: _unref(modal_field_content),
                container_style: {'max-width': '48rem'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, [
                          _createTextVNode(" You can use "),
                          _hoisted_10,
                          _createTextVNode(" to add styles to the content displayed for this node. Text containing HTML code will be rendered as HTML. "),
                          _createElementVNode("span", {
                            class: "ml-1 text-sm text-gray-800 cursor-pointer select-none hover:text-gray-700 hover:underline",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal_field_content).data.read_more = !_unref(modal_field_content).data.read_more))
                          }, _toDisplayString(_unref(modal_field_content).data.read_more ? 'less' : 'more'), 1)
                        ]),
                        (_unref(modal_field_content).data.read_more)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_11,
                              _hoisted_12
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(EasymdeView), {
                          options: {},
                          value: _unref(modal_field_content).data.editor,
                          onInput: _cache[1] || (_cache[1] = e => _unref(modal_field_content).data.editor = e)
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (modal_field_content_accept(_unref(modal_field_content)))),
                      type: "button",
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                    }, "Accept"),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(modal_field_content).close())),
                      type: "button",
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    }, "Cancel")
                  ])
                ]),
                _: 1
              }, 8, ["modal"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString((_ctx.cell.getData() as AntvNodeData).gd.variable ?? 
                    `${ (_ctx.cell.getData() as AntvNodeData).gd.type }_${_ctx.cell.id.toString().substring(0, 8)}`), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cell?.remove())),
                class: "btn btn-red"
              }, _hoisted_19)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current_fields.value, (fields, field_group) => {
              return (_openBlock(), _createElementBlock("div", { key: field_group }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(field_group.toString()[0].toUpperCase().concat(field_group.toString().substring(1))), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field,
                      class: "block mt-2 mb-1"
                    }, [
                      (field == 'variable')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                class: "style-soft w-full font-mono",
                                type: "text",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((node_variable).value = $event)),
                                placeholder: `${ (_ctx.cell.getData() as AntvNodeData).gd.type }_${_ctx.cell.id.toString().substring(0, 8)}`
                              }, null, 8, _hoisted_24), [
                                [_vModelText, node_variable.value]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (field == 'label')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("button", {
                                class: "btn text-sm",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(modal_field_content).open()))
                              }, _hoisted_29)
                            ]),
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("textarea", {
                                id: "textarea_content",
                                style: {"min-height":"4rem"},
                                class: "w-full style-soft",
                                type: "text",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((node_content).value = $event))
                              }, null, 512), [
                                [_vModelText, node_content.value]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_ctx.cell.isEdge())
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cell?.remove())),
                  class: "btn btn-red"
                }, _hoisted_34)
              ]),
              ((_ctx.cell.getSourceCell()?.getData() as AntvNodeData).gd.type == 'decision')
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", null, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "style-soft w-full",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((edge_content).value = $event))
                        }, null, 512), [
                          [_vModelText, edge_content.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          class: "inline btn mr-2",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (edge_content.value = 'Yes'))
                        }, "Yes"),
                        _createElementVNode("button", {
                          class: "inline btn",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (edge_content.value = 'No'))
                        }, "No")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
}
}

})